import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { 
      title: '登录',
      requiresAuth: false 
    }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '控制台' }
      },
      {
        path: '/news',
        redirect: '/news/list'
      },
      {
        path: '/doctor/list',
        name: 'DoctorList',
        component: () => import('@/views/doctor/DoctorList.vue'),
        meta: { title: '专家团队管理' }
      },
      {
        path: '/news/list',
        name: 'NewsList',
        component: () => import('@/views/news/NewsList.vue'),
        meta: { title: '资讯管理' }
      },
      {
        path: '/news/create',
        name: 'NewsCreate',
        component: () => import('@/views/news/NewsForm.vue'),
        meta: { title: '发布资讯' }
      },
      {
        path: '/news/edit/:id',
        name: 'NewsEdit',
        component: () => import('@/views/news/NewsForm.vue'),
        meta: { title: '编辑资讯' }
      },


      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/users/UsersList.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: '/leads',
        name: 'Leads',
        component: () => import('@/views/leads/LeadsList.vue'),
        meta: { title: '客资信息' }
      },
      {
        path: '/doctor/reviews',
        name: 'DoctorReviewList',
        component: () => import('@/views/doctor/DoctorReviewList.vue'),
        meta: { title: '医生评价管理' }
      }
      ,
      {
        path: '/packages/list',
        name: 'PackagesList',
        component: () => import('@/views/packages/PackagesList.vue'),
        meta: { title: '套餐管理' }
      },
      {
        path: '/orders/list',
        name: 'OrdersList',
        component: () => import('@/views/orders/OrdersList.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: '/live/list',
        name: 'LiveList',
        component: () => import('@/views/live/LiveList.vue'),
        meta: { title: '直播管理' }
      },
      {
        path: '/live/comments',
        name: 'LiveCommentManage',
        component: () => import('@/views/live/LiveCommentManage.vue'),
        meta: { title: '评论管理' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 无锡医博医院管理平台`
  }
  
  // 检查是否需要登录
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      next('/login')
      return
    }
    
    // 如果有token但用户信息为空，尝试获取用户信息
    if (!authStore.user) {
      try {
        await authStore.getUserInfo()
      } catch (error) {
        localStorage.removeItem('admin_token')
        next('/login')
        return
      }
    }
  }
  
  // 如果已登录且访问登录页，重定向到控制台
  if (to.path === '/login' && localStorage.getItem('admin_token')) {
    next('/dashboard')
    return
  }
  
  next()
})

export default router
